import { render, staticRenderFns } from "./list_role.vue?vue&type=template&id=445cf814&"
import script from "./list_role.vue?vue&type=script&lang=js&"
export * from "./list_role.vue?vue&type=script&lang=js&"
import style0 from "./list_role.vue?vue&type=style&index=0&id=445cf814&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports